import { RouteRecordRaw } from 'vue-router';

import BaseLayout from '@/layouts/base-layout.vue';
import { getStageIndexMeta } from '@/modules/onboarding/utils';

const personalPages = {
  information: () => import(
    '@/modules/onboarding/pages/SoleTrader/Personal/PersonalInformation.vue'
  ),
  address: () => import(
    '@/modules/onboarding/pages/SoleTrader/Personal/AddressPage.vue'
  ),
  verify: () => import(
    '@/modules/onboarding/pages/SoleTrader/Personal/VerifyPage.vue'
  ),
};
const businessPages = {
  information: () => import(
    '@/modules/onboarding/pages/SoleTrader/Business/BusinessInformation.vue'
  ),
  turnover: () => import(
    '@/modules/onboarding/pages/SoleTrader/Business/TurnoverPage.vue'
  ),
  verify: () => import(
    '@/modules/onboarding/pages/SoleTrader/Business/VerifyPage.vue'
  ),
};

const IdentityProof = () => import(
  '@/modules/onboarding/pages/SoleTrader/IdentityProof.vue'
);

const AddressProof = () => import(
  '@/modules/onboarding/pages/SoleTrader/AddressProof.vue'
);

const LiveScan = () => import(
  '@/modules/onboarding/pages/SoleTrader/LiveScan.vue'
);

const PricingPlan = () => import(
  '@/modules/onboarding/pages/SoleTrader/PricingPlan.vue'
);

const SoleTraderVerification = () => import(
  '@/modules/onboarding/pages/SoleTrader/VerificationPage.vue'
);

const STAGES = [
  'pages.onboarding.sole_trader.stages.personal_data',
  'pages.onboarding.sole_trader.stages.about_business',
  'pages.onboarding.sole_trader.stages.identity_proof',
  'pages.onboarding.sole_trader.stages.address_proof',
  'pages.onboarding.sole_trader.stages.liveness_check',
  'pages.onboarding.sole_trader.stages.plan',
];

const PERSONAL_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'data',
    name: 'onboarding-sole-trader-personal-data',
    component: personalPages.information,
    meta: getStageIndexMeta(0),
  },
  {
    path: 'address',
    name: 'onboarding-sole-trader-personal-address',
    component: personalPages.address,
    meta: getStageIndexMeta(0),
  },
  {
    path: 'verify',
    name: 'onboarding-sole-trader-personal-verify',
    component: personalPages.verify,
    meta: getStageIndexMeta(0),
  },
];

const BUSINESS_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'data',
    name: 'onboarding-sole-trader-business-data',
    component: businessPages.information,
    meta: getStageIndexMeta(1),
  },
  {
    path: 'turnover',
    name: 'onboarding-sole-trader-business-turnover',
    component: businessPages.turnover,
    meta: getStageIndexMeta(1),
  },
  {
    path: 'verify',
    name: 'onboarding-sole-trader-business-verify',
    component: businessPages.verify,
    meta: getStageIndexMeta(1),
  },
];

const SOLE_TRADER_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'personal',
    name: 'onboarding-sole-trader-personal',
    children: PERSONAL_CHILDREN,
    redirect: PERSONAL_CHILDREN[0],
  },
  {
    path: 'business',
    name: 'onboarding-sole-trader-business',
    children: BUSINESS_CHILDREN,
    redirect: BUSINESS_CHILDREN[0],
  },
  {
    path: 'proof-of-identity',
    name: 'onboarding-sole-trader-proof-of-identity',
    component: IdentityProof,
    meta: getStageIndexMeta(2),
  },
  {
    path: 'proof-of-address',
    name: 'onboarding-sole-trader-proof-of-address',
    component: AddressProof,
    meta: getStageIndexMeta(3),
  },
  {
    path: 'liveness-check',
    name: 'onboarding-sole-trader-liveness-check',
    component: LiveScan,
    meta: getStageIndexMeta(4),
  },
  {
    path: 'pricing',
    name: 'onboarding-sole-trader-pricing',
    component: PricingPlan,
    meta: getStageIndexMeta(5),
  },
  {
    path: 'verify',
    name: 'onboarding-sole-trader-verification',
    component: SoleTraderVerification,
    meta: {
      layout: {
        componentName: 'BaseLayoutWithLogout',
      },
    },
  },
];

export const SOLE_TRADER = {
  path: 'sole-trader',
  name: 'onboarding-sole-trader',
  children: SOLE_TRADER_CHILDREN,
  component: BaseLayout,
  props: {
    fetchProfile: false,
    baseLayoutConfig: {
      componentName: 'OnboardingSoleTraderLayout',
      props: {
        stages: STAGES,
      },
    },
  },
};
